import { render, staticRenderFns } from "./FormB.vue?vue&type=template&id=2c149406&scoped=true"
import script from "./FormB.vue?vue&type=script&lang=js"
export * from "./FormB.vue?vue&type=script&lang=js"
import style0 from "./FormB.vue?vue&type=style&index=0&id=2c149406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c149406",
  null
  
)

export default component.exports